import { render, staticRenderFns } from "./Project12Zh.vue?vue&type=template&id=055b62a4&scoped=true&"
import script from "./Project12Zh.vue?vue&type=script&lang=js&"
export * from "./Project12Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project12Zh.vue?vue&type=style&index=0&id=055b62a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b62a4",
  null
  
)

export default component.exports